export interface CarrierDefinition {
  id: string
  name: string
  color: string
  networks: string[]
}

export const CARRIER_COLORS: Record<string, string> = {
  'AT&T': '#009FDB',
  'T-Mobile': '#E20074',
  Verizon: '#CD040B',
  'US Cellular': '#00843D',
  FirstNet: '#003087',
}

export const CARRIERS: CarrierDefinition[] = [
  { id: 'att', name: 'AT&T', color: '#009FDB', networks: ['AT&T'] },
  { id: 'tmobile', name: 'T-Mobile', color: '#E20074', networks: ['T-Mobile'] },
  { id: 'verizon', name: 'Verizon', color: '#CD040B', networks: ['Verizon'] },
  { id: 'uscellular', name: 'US Cellular', color: '#00843D', networks: ['US Cellular'] },
  { id: 'firstnet', name: 'FirstNet', color: '#003087', networks: ['FirstNet'] },
]

const ROAMING_MAP: Record<string, string[]> = {
  'AT&T': ['AT&T', 'FirstNet', 'US Cellular'],
  'T-Mobile': ['T-Mobile', 'US Cellular'],
  Verizon: ['Verizon', 'US Cellular'],
  'US Cellular': ['US Cellular', 'AT&T', 'T-Mobile', 'Verizon'],
  FirstNet: ['FirstNet', 'AT&T'],

  'Google Fi': ['T-Mobile', 'US Cellular'],
  'Mint Mobile': ['T-Mobile'],
  Visible: ['Verizon'],
  'Cricket Wireless': ['AT&T'],
  'Metro by T-Mobile': ['T-Mobile'],
  'Boost Mobile': ['AT&T', 'T-Mobile'],
  'Straight Talk': ['AT&T', 'T-Mobile', 'Verizon'],
  'Consumer Cellular': ['AT&T', 'T-Mobile'],
  'Xfinity Mobile': ['Verizon'],
  'Spectrum Mobile': ['Verizon'],
  'Total Wireless': ['Verizon'],
  TracFone: ['AT&T', 'T-Mobile', 'Verizon'],
  'Simple Mobile': ['T-Mobile'],
  'Ultra Mobile': ['T-Mobile'],
  'H2O Wireless': ['AT&T'],
  'Net10 Wireless': ['AT&T', 'T-Mobile', 'Verizon'],
  'Republic Wireless': ['T-Mobile'],
  Ting: ['T-Mobile', 'Verizon'],
}

export function getNetworksForSimCarrier(simCarrier: string): string[] {
  const normalized = simCarrier.trim()
  const exact = ROAMING_MAP[normalized]
  if (exact) return exact

  const lower = normalized.toLowerCase()
  for (const [key, networks] of Object.entries(ROAMING_MAP)) {
    if (key.toLowerCase() === lower) return networks
  }

  return []
}

export function getCarrierIds(networkNames: string[]): string[] {
  return CARRIERS.filter(c => networkNames.includes(c.name)).map(c => c.id)
}
